import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { BodyTextLarge, BodyTextSmall } from 'Packages/FacetDesign/Components/BodyText';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('name', {
    _component: () => BodyTextLarge,
  }, overrideReadOnly)
  .nameOverride('description', {
    _component: () => BodyTextSmall,
  }, overrideReadOnly);

export default metaOverrideSet;
